// 获取浏览器类型
export const getUA = () => {
  let ua = typeof document !== 'undefined' ? window?.navigator?.userAgent : ''
  ua = ua?.toLowerCase()
  return ua
}

// 获取casId
export const getCasId = () => {
  let userInfo = ''
  try {
    userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : ''
  } catch (e) {
    console.error('解析 userInfo 失败:', e)
  }
  return userInfo?.id || ''
}
